import { Popover, Button, ButtonGroup, ButtonVariant, Position, Size } from "@blueprintjs/core" 
import IScalarForm from "src/libs/scalars/interface/IScalarForm" 
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { schema } from "src/modules/pe-landing-module/data/schema"
import ContentEditChildField from "./ContentEditChildField"
import { getEditedContent } from "./ContentEditBreadcrumbs"

/* Protopia Ecosystem component */
export interface IContentEditChildMenuProps {
   type: LANDING_TYPE_CONTENT 
   value: any
}
const ContentEditChildMenu = ({value, ...props}: IContentEditChildMenuProps): JSX.Element => {
    const isFull        = useSyncState<boolean>(false)
    const type          = useSyncState<IScalarForm | undefined>( undefined) 
    const apollo_fields = schema()[ props.type ].apollo_fields || {} 
    const noDefaults    = Object.keys( apollo_fields).filter((af: string) => !!apollo_fields[af].noDefault && !!apollo_fields[af].title )
    // const ec = getEditedContent()
    // const value         = !!ec ? ec[ props.type ] : {}
 
    return <div className='flex-centered flex-wrap max-w-100'>
        {
            Object.keys( apollo_fields)
                .filter((af: string) => isFull.get() ? !!apollo_fields[af].title : !apollo_fields[af].noDefault && !!apollo_fields[af].title )
                .filter((af: string) => {
                    if( Array.isArray(apollo_fields[af].required) ) {
                        const field = apollo_fields[af].required[0]
                        const require: any[]  = apollo_fields[af].required.slice(1)
                        return require.includes(value[field])
                    }
                    return true
                })
                .filter((af: string) => !apollo_fields[af].parent)
                .map(( af:string ) => { 
                    const subMenus: IScalarForm[] = Object.keys( apollo_fields)
                        .filter((pr: string) => {
                            if( Array.isArray(apollo_fields[pr].required) ) {
                                const field = apollo_fields[pr].required[0]
                                const require: any[]  = apollo_fields[pr].required.slice(1)
                                return require.includes(value[field])
                            }
                            return true
                        })
                        .filter((pr: string) => apollo_fields[pr].parent === af)
                        .map(pr => apollo_fields[pr])
                    return <Popover
                        key={af}
                        position={Position.TOP}
                        content={
                                <ContentEditChildField
                                    type={  apollo_fields[ af ] }
                                    value={ value ? value[ af ] : [] }
                                    subMenus={ subMenus }
                                    origin={ value }
                                />
                        }
                    >
                        <Button variant="minimal" size="small">
                            <div className="micro text-light text-nowrap text-uppercase">
                                { __( apollo_fields[af].title ) }
                            </div>
                        </Button>
                    </Popover>
                })
        } 
        {
            !!noDefaults.length && 
            <Button 
                size={Size.SMALL} 
                variant={ButtonVariant.MINIMAL} 
                className="btn-stretch small hint hint--top" 
                onClick={() => isFull.set(!isFull.get())}
                data-hint={__(isFull.get() ? "Less" : "Larger")}
            >
                <i className={`fas fa-chevron-${ isFull.get() ? "left" : "right" } text-light`} /> 
            </Button>
        }
    </div> 
}
export default ContentEditChildMenu